import Component from "@ember/component"
import { action, computed } from "@ember/object"
import { scheduleOnce } from "@ember/runloop"
import { filter, includes, intersection, map } from "lodash-es"

export default class Outline extends Component {
  // args
  queryResults!: Array<any>
  dates!: Array<any>
  onNewFocusedItemId!: Function
  focusedItemId!: string
  hasNotYetScrolled = true

  // state
  _lastFocusedItemId: string | null = null

  didReceiveAttrs() {
    scheduleOnce("afterRender", this, () => {
      if (this.dates && this.focusedItemId && this.hasNotYetScrolled) {
        // let $el = this.$(`#${get(this, "focusedItemId")}`)
        let $el = $(`.course-outline-date-wrapper[data-date-string="${this.focusedItemId}"]`)
        if ($el === undefined) return
        let el = $el[0]
        if (el === undefined) return
        let { top, bottom } = el.getBoundingClientRect()
        const vHeight = window.innerHeight || document.documentElement.clientHeight
        let isVisible = (top > 0 || bottom > 0) && top < vHeight
        if (!isVisible) {
          top = top - 100
          $(".course-outline-wrapper", this.element).scrollTop(top)
          this.hasNotYetScrolled = false
        }
      }
    })

    // When focusedItemId changes, focus on the input field in DateRow / UnitRow.

    if (this.focusedItemId && this.focusedItemId !== this._lastFocusedItemId) {
      const focusedItemId = this.focusedItemId
      scheduleOnce("afterRender", this, function () {
        if (this.isDestroyed || this.isDestroying) return
        let el = $(`.js-course-outline-input[data-course-outline-input-id="${focusedItemId}"]`)[0]
        if (el) el.focus()
      })

      this._lastFocusedItemId = this.focusedItemId
    }
  }

  @computed("dates", "queryResults")
  get filteredDates() {
    if (this.queryResults !== null) {
      let validIds = map(this.queryResults, (result) => result.id)
      return filter(this.dates, (date) => {
        return includes(validIds, date.id) || intersection(validIds, date.unitIds).length > 0
      })
    } else {
      return this.dates
    }
  }

  @action
  onFocusIn(_type, id) {
    if (this.focusedItemId === id) return true
    this.onNewFocusedItemId(id)
    return null
  }

  @action
  arrowUpDown(currentTotalIndex, direction) {
    let index = direction === "up" ? currentTotalIndex - 1 : currentTotalIndex + 1
    let dateOrUnit = this.filteredDates[index]
    if (dateOrUnit) {
      this.onNewFocusedItemId(dateOrUnit.dateString || dateOrUnit.id)
    }
  }
}
